import React from 'react';
import { Link } from 'react-router-dom';
import { Check, Minus, ArrowRight, Loader2, Star } from 'lucide-react';

export const TOOL_LABELS = {
  clarity_hub: 'Clarity Hub', jumpstart: '7-Stage Jumpstart', nonprofit: 'Nonprofit Accelerator',
  website_vision: 'Website Vision Builder', blueprint: 'My Blueprint', live_training: 'Live Training', social_studio: 'Social Studio',
};

export const ROWS = [
  ['sessions', 'Coaching'],
  ['checkins', 'Check-ins'],
  ['support', 'Support'],
  ['planning', 'Planning'],
];

const Row = ({ label, value }) => (
  <li className="flex items-start gap-2.5 py-2 border-b last:border-0" style={{ borderColor: 'var(--p-border)' }}>
    {value ? <Check size={15} className="text-emerald-500 mt-0.5 shrink-0" /> : <Minus size={15} className="mt-0.5 shrink-0" style={{ color: 'var(--p-faint)' }} />}
    <span className="text-[11px] uppercase tracking-wider font-semibold w-20 shrink-0 mt-0.5" style={{ color: 'var(--p-faint)' }}>{label}</span>
    <span className="text-sm" style={{ color: value ? 'var(--p-text)' : 'var(--p-faint)' }}>{value || 'Not included'}</span>
  </li>
);

export default function ProgramCard({ p, busy, onEnroll }) {
  const inc = p.tools_included || [];
  const allCore = ['clarity_hub', 'jumpstart', 'nonprofit', 'website_vision', 'blueprint'].every((t) => inc.includes(t));
  const tools = allCore
    ? ['All 5 coaching tools', ...inc.filter((t) => ['live_training', 'social_studio'].includes(t)).map((t) => TOOL_LABELS[t])]
    : inc.map((t) => TOOL_LABELS[t]).filter(Boolean);
  const single = p.package_id === 'pkg_dca_strategy';
  return (
    <div className={`relative p-card rounded-2xl p-6 flex flex-col transition-transform hover:-translate-y-1 ${p.popular ? 'ring-2 ring-[#F97316]' : ''}`} data-testid={`offer-program-${p.package_id}`}>
      {p.popular && (
        <span className="absolute -top-3 left-6 inline-flex items-center gap-1 bg-[#F97316] text-white text-[11px] font-bold uppercase tracking-wider px-3 py-1 rounded-full">
          <Star size={11} fill="currentColor" /> Most popular
        </span>
      )}
      <div className="text-xs font-semibold uppercase tracking-wider" style={{ color: single ? 'var(--p-faint)' : '#1D4ED8' }}>{single ? 'One-time session' : `${p.duration_label} program`}</div>
      <h3 className="text-xl font-semibold mt-1 leading-snug" style={{ fontFamily: 'Outfit, sans-serif' }}>{p.name}</h3>
      <p className="text-sm mt-1" style={{ color: 'var(--p-muted)' }}>{p.tagline}</p>
      <div className="flex items-baseline gap-1.5 mt-4 mb-1">
        <span className="text-4xl font-bold tracking-tight" data-testid={`offer-price-${p.package_id}`}>${Number(p.price).toLocaleString()}</span>
        <span className="text-sm" style={{ color: 'var(--p-faint)' }}>{single ? 'one-time' : `/ ${p.duration_label}`}</span>
      </div>
      <p className="text-xs mb-4" style={{ color: 'var(--p-faint)' }}>Best for: {p.best_for}</p>
      <ul className="mb-4">
        {ROWS.map(([k, label]) => <Row key={k} label={label} value={p.inclusions?.[k]} />)}
        <Row label="Tools" value={tools.length ? tools.join(', ') : null} />
        <Row label="Businesses" value={p.business_limit ? `${p.business_limit} business` : 'Unlimited businesses'} />
      </ul>
      <div className="mt-auto space-y-2">
        <button onClick={() => onEnroll(p)} disabled={busy} data-testid={`offer-enroll-${p.package_id}`}
          className={`w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl font-semibold text-sm text-white transition-colors disabled:opacity-60 ${p.popular ? 'bg-[#F97316] hover:bg-[#EA580C]' : 'bg-[#1D4ED8] hover:bg-[#2563EB]'}`}>
          {busy ? <Loader2 size={15} className="animate-spin" /> : null} {single ? 'Book & pay' : 'Enroll now'} <ArrowRight size={15} />
        </button>
        <Link to="/portal/book" data-testid={`offer-talk-${p.package_id}`} className="block text-center text-sm font-medium hover:underline" style={{ color: 'var(--p-muted)' }}>
          Talk to David first (free 20-min call)
        </Link>
      </div>
    </div>
  );
}
